__turbopack_context__.v({
  "blok-big-title": "RelatedProductsCarousel-module__wkHSVW__blok-big-title",
  "blok-subtitle": "RelatedProductsCarousel-module__wkHSVW__blok-subtitle",
  "blok-title": "RelatedProductsCarousel-module__wkHSVW__blok-title",
  "carousel": "RelatedProductsCarousel-module__wkHSVW__carousel",
  "embla": "RelatedProductsCarousel-module__wkHSVW__embla",
  "embla__container": "RelatedProductsCarousel-module__wkHSVW__embla__container",
  "embla__slide": "RelatedProductsCarousel-module__wkHSVW__embla__slide",
  "gallery-button": "RelatedProductsCarousel-module__wkHSVW__gallery-button",
  "gallery-button-wrapper": "RelatedProductsCarousel-module__wkHSVW__gallery-button-wrapper",
  "heading-2": "RelatedProductsCarousel-module__wkHSVW__heading-2",
  "right": "RelatedProductsCarousel-module__wkHSVW__right",
});
